module.exports = __webpack_public_path__ + "img/background2.ca478558.png";